import React, { useState } from 'react';
import unit1Data from '../data/missionData.json';
import unit2Data from '../data/unit2Data.json';

export default function VocabularyHub() {
  const [selectedUnit, setSelectedUnit] = useState('unit1');
  const [flippedCardId, setFlippedCardId] = useState(null);

  // Consolidamos vocabulario de ejemplo para cada unidad basado en sus datos pedagógicos
  const vocabularyData = {
    unit1: [
      { id: 'v1-1', term: 'Boarding Pass', translation: 'Pase de abordar', example: 'Please show your boarding pass at the gate.', unit: 'Unidad 1: Aeropuerto' },
      { id: 'v1-2', term: 'Luggage / Baggage', translation: 'Equipaje', example: 'Where is the luggage claim area?', unit: 'Unidad 1: Aeropuerto' },
      { id: 'v1-3', term: 'Gate', translation: 'Puerta de embarque', example: 'Our flight departs from gate number 4.', unit: 'Unidad 1: Aeropuerto' },
      { id: 'v1-4', term: 'Passport Control', translation: 'Control de pasaportes', example: 'We need to pass through passport control.', unit: 'Unidad 1: Aeropuerto' }
    ],
    unit2: [
      { id: 'v2-1', term: 'Backpack', translation: 'Mochila / Maleta', example: 'My notebook is inside my backpack.', unit: 'Unidad 2: Aduanas' },
      { id: 'v2-2', term: 'Daily Routine', translation: 'Rutina diaria', example: 'She gets up early every morning.', unit: 'Unidad 2: Aduanas' },
      { id: 'v2-3', term: 'Personal Items', translation: 'Objetos personales', example: 'Please place your personal items in the tray.', unit: 'Unidad 2: Aduanas' },
      { id: 'v2-4', term: 'Possessive Adjectives', translation: 'Adjetivos posesivos (my, his, her)', example: 'This is not my passport, this is his passport.', unit: 'Unidad 2: Aduanas' }
    ]
  };

  const currentList = vocabularyData[selectedUnit];

  const handleFlip = (id) => {
    setFlippedCardId(flippedCardId === id ? null : id);
  };

  return (
    <div className="bg-slate-800/90 border border-slate-700/80 rounded-2xl p-6 sm:p-8 shadow-2xl space-y-8 backdrop-blur-sm text-slate-100">
      
      {/* ENCABEZADO */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-slate-700 pb-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-tr from-purple-600 to-indigo-500 flex items-center justify-center text-3xl shadow-lg shadow-purple-600/30 shrink-0">
            📚
          </div>
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-purple-300 bg-purple-950/80 px-3 py-1 rounded-full border border-purple-500/30">
              Centro de Aprendizaje Autónomo
            </span>
            <h2 className="text-2xl font-black text-white mt-2">
              Glosario y Flashcards Interactivas
            </h2>
            <p className="text-slate-400 text-xs sm:text-sm mt-0.5">
              Refuerza tu vocabulario clave antes de cada misión
            </p>
          </div>
        </div>

        {/* SELECTOR DE UNIDAD */}
        <div className="flex items-center gap-2 bg-slate-900/90 p-1.5 rounded-xl border border-slate-700 w-full sm:w-auto">
          <button
            onClick={() => { setSelectedUnit('unit1'); setFlippedCardId(null); }}
            className={`flex-1 sm:flex-initial px-4 py-2 rounded-lg text-xs font-bold transition-all ${
              selectedUnit === 'unit1' ? 'bg-purple-600 text-white shadow' : 'text-slate-400 hover:text-white'
            }`}
          >
            ✈️ Unidad 1
          </button>
          <button
            onClick={() => { setSelectedUnit('unit2'); setFlippedCardId(null); }}
            className={`flex-1 sm:flex-initial px-4 py-2 rounded-lg text-xs font-bold transition-all ${
              selectedUnit === 'unit2' ? 'bg-purple-600 text-white shadow' : 'text-slate-400 hover:text-white'
            }`}
          >
            🧳 Unidad 2
          </button>
        </div>
      </div>

      {/* DESCRIPCIÓN DE LA SECCIÓN */}
      <div className="bg-slate-900/70 border border-slate-700/60 rounded-xl p-4 flex items-center justify-between gap-4">
        <div>
          <h3 className="text-sm font-bold text-white">💡 Tarjetas de Repaso Rápido (Flashcards)</h3>
          <p className="text-xs text-slate-400 mt-0.5">Haz clic en cualquier tarjeta para voltearla y ver su traducción al español y ejemplo de uso.</p>
        </div>
        <span className="text-xs font-mono bg-purple-950 text-purple-300 px-3 py-1 rounded-md border border-purple-500/30 shrink-0">
          {currentList.length} Términos
        </span>
      </div>

      {/* GRILLA DE FLASHCARDS INTERACTIVAS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {currentList.map((item) => {
          const isFlipped = flippedCardId === item.id;
          return (
            <div
              key={item.id}
              onClick={() => handleFlip(item.id)}
              className={`h-44 rounded-xl border p-5 cursor-pointer transition-all duration-300 flex flex-col justify-between select-none shadow-lg ${
                isFlipped
                  ? 'bg-purple-950/40 border-purple-500/60 shadow-purple-950/50'
                  : 'bg-slate-900/80 border-slate-700/80 hover:border-slate-600'
              }`}
            >
              <div className="flex justify-between items-start">
                <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 bg-slate-800 px-2.5 py-1 rounded border border-slate-700">
                  {item.unit}
                </span>
                <span className="text-xs text-purple-400 font-bold">
                  {isFlipped ? '🔄 Ver Término' : '🔄 Voltear tarjeta'}
                </span>
              </div>

              <div className="text-center my-auto">
                {!isFlipped ? (
                  <div>
                    <h4 className="text-xl font-black text-white tracking-tight">
                      {item.term}
                    </h4>
                    <p className="text-xs text-slate-500 mt-1">Haz clic para descubrir significado</p>
                  </div>
                ) : (
                  <div className="space-y-1.5 animate-fadeIn">
                    <h4 className="text-lg font-bold text-purple-300">
                      {item.translation}
                    </h4>
                    <p className="text-xs text-slate-300 italic">
                      "{item.example}"
                    </p>
                  </div>
                )}
              </div>

              <div className="text-[10px] text-center text-slate-500 font-mono">
                Grado Séptimo • Inglés Comunicativo
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}